//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Lund_Mackay",
  data() {
    return {
      form2: {
        maxillarySinusLeft: "",
        anteriorEthmoidSinusLeft: "",
        posteriorEthmoidSinusLeft:"",
        phenoidSinusLeft:"",
        frontalSinusLeft:"",
        OstiomeatalComplexLeft:"",
      },
      form1:{
        maxillarySinusRight: "",
        anteriorEthmoidSinusRight: "",
        posteriorEthmoidSinusRight:"",
        phenoidSinusRight:"",
        frontalSinusRight:"",
        OstiomeatalComplexRigth:"",
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: "0", name: "无异常" },
        { value: "1", name: "部分浑浊" },
        { value: "2", name: "完全浑浊" },
      ],
      dataList2: [
        { value: "0", name: "无阻塞" },
        { value: "2", name: "阻塞" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form2 = JSON.parse(JSON.stringify(self.form2));
      let flag = true;
      let result = 0;
      for (const key in form2) {
        if (form2.hasOwnProperty(key)) {
          if (!form2[key]) {
            flag = false;
          } else {
            form2[key] = Number(form2[key]);
          }
        }
        result += Number(form2[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
    score1() {
      let self = this;
      let form1 = JSON.parse(JSON.stringify(self.form1));
      let flag = true;
      let result = 0;
      for (const key in form1) {
        if (form1.hasOwnProperty(key)) {
          if (!form1[key]) {
            flag = false;
          } else {
            form1[key] = Number(form1[key]);
          }
        }
        result += Number(form1[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Lund_Mackay.vue